import { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import TelerouteForm from "./Teleroute";
import TransForm from "./Trans";

import { useTranslation } from "react-i18next";
import { useGetIntegrationStatusQuery } from "../integrationsApiSlice";
import { ComarrForm } from "./Comarr";
import { CompanionApp } from "./Timocom/companion-app";
import { TransporeonForm } from "./Transporeon";

const UserIntegrations = ({ user, isLoadingUser }) => {
	const { t } = useTranslation();
	const userCompanyId = user?.companyId;
	const { data, isLoading } = useGetIntegrationStatusQuery();
	const [expanded, setExpanded] = useState({
		timocom: false,
		trans: false,
		teleroute: false,
		transporeon: false,
		comarr: false,
	});

	return (
		<>
			<Accordion
				expanded={expanded.timocom}
				onChange={() =>
					setExpanded({ ...expanded, timocom: !expanded.timocom })
				}
			>
				<AccordionSummary
					expandIcon={expanded.timocom ? <RemoveIcon /> : <AddIcon />}
					aria-controls="timocom-content"
					id="timocom-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TIMOCOM</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<CompanionApp />
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded.trans}
				onChange={() => setExpanded({ ...expanded, trans: !expanded.trans })}
			>
				<AccordionSummary
					expandIcon={expanded.trans ? <RemoveIcon /> : <AddIcon />}
					aria-controls="trans-content"
					id="trans-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TRANS</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading || isLoadingUser ? (
						<Skeleton variant="rectangular" height={75.8} width={882} />
					) : (
						<TransForm
							hasCustomTransConnection={data?.hasCustomTransConnection}
							status={data?.transEuStatus}
							loginType={data?.transAuthType}
						/>
					)}
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded.teleroute}
				onChange={() =>
					setExpanded({ ...expanded, teleroute: !expanded.teleroute })
				}
			>
				<AccordionSummary
					expandIcon={expanded.teleroute ? <RemoveIcon /> : <AddIcon />}
					aria-controls="teleroute-content"
					id="teleroute-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TELEROUTE</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading || isLoadingUser ? (
						<Skeleton variant="rectangular" height={138} width={882} />
					) : (
						<TelerouteForm
							status={data?.telerouteStatus}
							telerouteClientID={data?.telerouteClientID}
							telerouteClientSecret={data?.telerouteClientSecret}
							telerouteUsername={data?.telerouteUsername}
							teleroutePassword={data?.teleroutePassword}
							enableEdit={user?.role === "admin"}
						/>
					)}
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded.transporeon}
				onChange={() =>
					setExpanded({ ...expanded, transporeon: !expanded.transporeon })
				}
			>
				<AccordionSummary
					expandIcon={expanded.transporeon ? <RemoveIcon /> : <AddIcon />}
					aria-controls="transporeon-content"
					id="transporeon-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TRANSPOREON</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading || isLoadingUser ? (
						<Skeleton variant="rectangular" height={138} width={882} />
					) : (
						<TransporeonForm
							status={data?.transporeonStatus}
							transporeonEmail={data?.transporeonEmail}
							transporeonCompany={data?.transporeonCompanyName}
						/>
					)}
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded.comarr}
				onChange={() => setExpanded({ ...expanded, comarr: !expanded.comarr })}
			>
				<AccordionSummary
					expandIcon={expanded.comarr ? <RemoveIcon /> : <AddIcon />}
					aria-controls="comarr-content"
					id="comarr-header"
				>
					<Typography sx={{ color: "#0069B4" }}>COMARR</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading || isLoadingUser ? (
						<Skeleton variant="rectangular" height={138} width={882} />
					) : (
						<ComarrForm
							status={data?.comarrStatus}
							comarrLogin={data?.comarrLogin}
							comarrPassword={data?.comarrPassword}
						/>
					)}
				</AccordionDetails>
			</Accordion>
		</>
	);
};

export default UserIntegrations;
